import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import './index.css';


const ALL_MONTHS = [
  { short: 'Jan', full: 'January' }, { short: 'Feb', full: 'February' }, { short: 'Mar', full: 'March' },
  { short: 'Apr', full: 'April' }, { short: 'May', full: 'May' }, { short: 'Jun', full: 'June' },
  { short: 'Jul', full: 'July' }, { short: 'Aug', full: 'August' }, { short: 'Sep', full: 'September' },
  { short: 'Oct', full: 'October' }, { short: 'Nov', full: 'November' }, { short: 'Dec', full: 'December' },
];

const RevenueCharts = ({ monthlyData, title = 'Monthly Revenue' }) => {
  const dataMap = Object.fromEntries((monthlyData || []).map(d => [d.month, d.revenue]));
  const chartData = ALL_MONTHS.map(({ short, full }) => ({ month: short, revenue: dataMap[full] ?? null }));
  const symbol = '₹';  


  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <p className="label">{label || payload[0].name}</p>
          <p className="value">{symbol}{payload[0].value?.toLocaleString('en-IN') || 0}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="revenue-charts">
      {/* {projectData && (
        <div className="chart-card">
          <h5 className="chart-title">Overall Revenue by Project</h5>
          <div className="chart-container">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={projectData}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  outerRadius={100}
                  dataKey="revenue"
                  nameKey="name"
                  label={({ name, percent }) => `${name} (${(percent * 100).toFixed(0)}%)`}
                >
                  {projectData.map((_, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip content={<CustomTooltip />} />
                <Legend />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      )} */}

      <div className="chart-card">
        <h5 className="chart-title">{title}</h5>
        <div className="chart-container">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
              <XAxis dataKey="month" />
              <YAxis tickFormatter={(v) => `${symbol}${v / 1000}k`} />
              <Tooltip content={<CustomTooltip />} />
              <Bar dataKey="revenue" name="Revenue" fill="#667eea" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default RevenueCharts;